export default __webpack_public_path__ + "gc-logo.png";